(() => {
  const PROPERTY_NAMES = [
    'properties[ギフト購入]',
    'properties[ギフト購入メッセージ]',
    'properties[ギフト贈り主]',
    'properties[メッセージカード]'
  ];

  function getCartAddForms() {
    return [...document.querySelectorAll('form')]
      .filter(form => {
        return (
          form instanceof HTMLFormElement &&
          form.action &&
          form.action.includes('/cart/add')
        );
      });
  }

  function getPropertyValues() {
    const values = {};

    PROPERTY_NAMES.forEach(name => {
      const elements = document.querySelectorAll(`[name="${CSS.escape(name)}"]`);

      for (const el of elements) {
        if (el.value) {
          values[name] = el.value;
          break;
        }
      }
    });

    return values;
  }

  function syncAnyGiftPropertiesToAllForms() {
    const values = getPropertyValues();

    if (!Object.keys(values).length) {
      return;
    }

    const forms = getCartAddForms();

    forms.forEach(form => {
      Object.entries(values).forEach(([name, value]) => {
        let input = form.querySelector(`[name="${CSS.escape(name)}"]`);

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }

        input.value = value;
      });
    });
  }

  /*
   * 重要：
   * 最初のsubmit時点ではAnyGiftのpropertiesが存在しているので、
   * Gift Optionが別フォームをrequestSubmitする前に、
   * 全ての商品フォームへコピーする。
   */
  document.addEventListener(
    'submit',
    event => {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        !form.action.includes('/cart/add')
      ) {
        return;
      }

      syncAnyGiftPropertiesToAllForms();
    },
    true
  );

  /*
   * AnyGiftがhidden inputを生成したタイミングでも同期。
   * DOM変更後に少し遅らせてコピーする。
   */
  const observer = new MutationObserver(() => {
    const hasAnyGiftProperty = PROPERTY_NAMES.some(name =>
      document.querySelector(`[name="${CSS.escape(name)}"]`)
    );

    if (hasAnyGiftProperty) {
      setTimeout(syncAnyGiftPropertiesToAllForms, 0);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  console.log('[AnyGift Fix] loaded');
})();